import type { RequestClient } from 'shared/library/api-client';
import { apiRoute } from 'shared/library/api-route';

export async function loadUnreadCount(
  request: RequestClient,
  setUnreadCount: (count: number) => void,
) {
  let data: { unread_count: number };

  try {
    data = await request<{ unread_count: number }>(apiRoute('conversations.get-unread-count'));
  } catch {
    // The badge is optional. Keep its current state on transient network failures.
    return;
  }

  setUnreadCount(data.unread_count);
}
